<form [formGroup]="userEditForm">
  <div class="form-row row" [hidden]="isUserInRole(Role.InterfaceServiceAccess)">
    <div class="form-group col-md-6">
      <label for="firstname" class="control-label required">{{ 'i18n.base.user-add-modal.firstname' | translate }}</label>
      <input id="firstname" type="text" class="form-control" formControlName="firstname" />
      <app-error-messages [control]="formFields.firstname"></app-error-messages>
    </div>
    <div class="form-group col-md-6">
      <label for="lastname" class="control-label required">{{ 'i18n.base.user-add-modal.lastname' | translate }}</label>
      <input id="lastname" type="text" class="form-control" formControlName="lastname" />
      <app-error-messages [control]="formFields.lastname"></app-error-messages>
    </div>
  </div>
  <div class="form-row row" [hidden]="isUserInRole(Role.InterfaceServiceAccess)">
    <div class="form-group col-md-12">
      <label for="email" class="control-label required">{{ 'i18n.base.user-add-modal.email' | translate }}</label>
      <input id="email" type="email" class="form-control" formControlName="email" />
      <app-error-messages [control]="formFields.email"></app-error-messages>
    </div>
  </div>
  <div class="form-row row" [hidden]="isUserInRole(Role.InterfaceServiceAccess)">
    @if (!hideClient()) {
      <div class="form-group col-md-6">
        <label for="client" class="control-label" [ngClass]="{'required': isClientRequired}">{{
          'i18n.base.user-management.column-headers.client' |
        translate }}</label>
        <app-client-autocomplete class="client-autocomplete" formControlName="client"
        placeholder=""></app-client-autocomplete>
      </div>
    }
    @if (!isUserInRole(Role.InterfaceServiceAccess)) {
      <div class="form-group col-md-{{hideClient()?'12':'6'}}">
        <label for="language" class="control-label required">{{ 'i18n.base.user-add-modal.language' | translate }}</label>
        <ejs-dropdownlist [dataSource]="languageDropDownItems" [fields]="languageDropdownSettings" [showClearButton]="true"
          formControlName="language">
        </ejs-dropdownlist>
        <app-error-messages [control]="formFields.language"></app-error-messages>
      </div>
    }
  </div>
  <div class="form-row row" [hidden]="!isUserInRole(Role.InterfaceServiceAccess)">
    @if (!hideClient()) {
      <div class="form-group col-md-12">
        <label for="client" class="control-label" [ngClass]="{'required': isClientRequired}">{{
          'i18n.base.user-management.column-headers.client' |
        translate }}</label>
        <app-client-autocomplete class="client-autocomplete" formControlName="client"
        placeholder=""></app-client-autocomplete>
      </div>
    }
  </div>
  <div class="form-row row" [hidden]="isUserInRole(Role.AssetStorageGroupMember)">
    <div class="form-group col-md-12">
      <label for="userName" class="control-label required">{{ 'i18n.base.user-management.column-headers.userName' | translate }}</label>
      <input id="userName" type="text" class="form-control" formControlName="userName" />
      <app-error-messages [control]="formFields.userName"></app-error-messages>
    </div>
  </div>
  <div class="form-row row" [hidden]="isLoggedInUser">
    @if (doesUserNeedPasswordField()) {
      <div class="form-group col-md-12">
        <label for="password" class="control-label" [ngClass]="{'required': isAdd || doesUserNeedPasswordField()}">
          {{ 'i18n.base.user-management.column-headers.password' | translate }}
        </label>
        <div class="wrap">
          <div class="password-generator-input e-input-group" [ngClass]="{'e-error': hasError(formFields.password)}">
            <input id="password" type="password" autocomplete="new-password" class="e-input form-control"
              formControlName="password" appPasswordVisibility>
            <span class="e-input-group-icon"
              title="{{ 'i18n.domain.export-configuration.configurations.forms.rest.form-fields.client-secret-tooltip' | translate }}"
              (click)="generatePassword()">
              <span class="e-icons icon-reset--alt"></span>
            </span>
          </div>
          <app-error-messages [control]="formFields.password"></app-error-messages>
        </div>
      </div>
    }
  </div>
  <div class="form-row row" [hidden]="!isUserInRole(Role.InterfaceServiceAccess)">
    <div class="form-group col-md-12">
      <label for="emailIsServiceAccount" class="control-label required">{{ 'i18n.base.user-add-modal.email' | translate }}</label>
      <input id="emailIsServiceAccount" type="email" class="form-control" formControlName="email" />
      <app-error-messages [control]="formFields.email"></app-error-messages>
    </div>
  </div>
  <div class="form-row row" [hidden]="isUserInRole(Role.InterfaceServiceAccess)">
    <div class="form-group col-md-12">
      <label for="phoneNumber">
        {{ 'i18n.base.user-add-modal.phoneNumber' | translate }}
        <span class="required-asterisk"></span>
      </label>
      <input id="phoneNumber" type="text" class="form-control" formControlName="phoneNumber" />
      <app-error-messages [control]="formFields.phoneNumber"></app-error-messages>
    </div>
  </div>
  <div class="form-row row" [hidden]='!userEditForm.controls.roles.value.length || isAdd'>
    <div class="form-group col-md-12">
      <label class="d-block">{{ 'i18n.base.role-assignment.roles' | translate }}</label>
      <span>{{formatRoles(userEditForm.controls.roles.value)}}</span>
    </div>
  </div>
  @if (!isAdd && !isLoggedInUser && !isDomainUser) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label for="enabled" class="d-block">{{ 'i18n.base.user-add-modal.status' | translate }}</label>
        <app-yes-no-group-button id="enabled" formControlName="enabled"
        i18nTranslationKeyPrefix="i18n.base.user-add-modal.status-type"></app-yes-no-group-button>
      </div>
    </div>
  }
</form>
